import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { IVersion } from 'services/types';

export interface ITimestamp {
  start: string;
  end: string;
}

export enum AsapType {
  None = 1,
  AsapToDate = 2,
  Asap = 3,
}

export interface IDigitalDeliveryBase {
  asap: AsapType;
  isTimeZoneBased: boolean;
  countryCode: string;
  publishDate: string;
  publishTime: string;
  subscriptionTypeId: number;
  endDate: null | string;
  endTime: null | string;
}

export interface IDigitalDeliveryIdentificators {
  productId: string;
  salesChannelId: string;
  providerId: string;
}

export enum YT_CONTENT_MATCH_POLICY {
  Monetize = 0,
  Block = 1,
  Track = 2,
}

export interface IDigitalDeliveryMutation extends IDigitalDeliveryIdentificators {
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  version: number;
  timestamps?: ITimestamp | null;
  cutTimestamps?: ITimestamp | null;
  isReconnection: boolean;
  ytContentMatchPolicy?: YT_CONTENT_MATCH_POLICY | null;
}

export interface IDigitalDeliveryForm {
  id: string;
  salesChannelName: string;
  providerName: string;
  salesChannelLogo: string | null;
  deliveryType: DELIVERY_METHOD;
  status: DELIVERY_STATUS;
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  version: number;
  timestamp?: ITimestamp | null;
  expectTimestamp?: boolean | null;
  waitForAssetId?: boolean;
  transferMethod?: TRANSFER_METHOD;
  hasDiscrepancy?: boolean | null;
  acceptVideoWithTrack?: boolean;
  isReconnection: boolean;
  requireYtContentMatchPolicy?: boolean;
  ytContentMatchPolicy?: YT_CONTENT_MATCH_POLICY | null;
}

export interface ICreateDigitalDelivery extends IDigitalDeliveryMutation {}

export interface IUpdateDigitalDelivery extends IDigitalDeliveryMutation {}

export interface ICreateAllDigitalDeliveries {
  productId: string;
  priority: boolean;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  timestamps?: ITimestamp | null;
  cutTimestamps?: ITimestamp | null;
  isReconnection: boolean;
  ytContentMatchPolicy?: YT_CONTENT_MATCH_POLICY | null;
}

export interface IUpdateAllDigitalDeliveries extends ICreateAllDigitalDeliveries {}

export interface ICancelDigitalDelivery {
  productId: string;
  salesChannel?: string;
  providerId?: string;
}

export interface ICancelAllDigitalDelivery {
  productId: string;
}

export interface IAcceptAllDigitalDelivery {
  productId: string;
}

export interface IWithdrawAllDigitalDelivery {
  productId: string;
  priority: boolean;
}

export interface IAcceptDigitalDelivery extends IVersion {
  productId: string;
  salesChannelId: string;
  providerId: string;
}

export interface IWithdrawDigitalDelivery extends Omit<
  IDigitalDeliveryIdentificators,
  'salesChannelId' | 'providerId'
> {
  salesChannelId?: string;
  providerId?: string;
  priority: boolean;
}

export interface IUnsupportedRolesParams {
  digitalMusicProductId: string;
  salesChannelId: string;
}

export type IUnsupportedRolesResponse = number[];

export interface IUpdateDigitalDeliveryStatus extends ICancelDigitalDelivery {
  statusId: DELIVERY_STATUS;
}

export interface IDigitalDeliveryResponse extends IDigitalDeliveryMutation {
  id: string;
  salesChannelName: string;
  salesChannelLogo: string | null;
  providerName: string;
  deliveryMethod: DELIVERY_METHOD;
  deliveryType: DELIVERY_METHOD;
  status: DELIVERY_STATUS;
  version: number;
  timestamp?: ITimestamp | null;
  expectTimestamp?: boolean | null;
  hasDiscrepancy: boolean | null;
  acceptVideoWithTrack?: boolean;
  isReconnection: boolean;
  requireYtContentMatchPolicy?: boolean;
  ytContentMatchPolicy?: YT_CONTENT_MATCH_POLICY | null;
}

export interface IDigitalDeliveryInformationResponse {
  delivery: IDigitalDeliveryResponse | null;
  hasDeliveryToAccept: boolean;
  insert: boolean;
}

export interface IDigitalDeliveryHistoryItem {
  id: string;
  productId: string;
  salesChannelId: string;
  salesChannelName: string;
  acceptVideoWithTrack: boolean;
  salesChannelLogo: string | null;
  providerId: string;
  providerName: string;
  deliveryType: number;
  transferMethod: number;
  waitForAssetId: boolean;
  expectTimestamp: boolean;
  status: number;
  packageFolder: string | null;
  included: IDigitalDeliveryBase[];
  excluded: IDigitalDeliveryBase[];
  createdAt: string;
  editedAt: string;
  timestamp: ITimestamp | null;
  hasDiscrepancy: boolean;
  version: number;
  isReconnection?: boolean;
  ytContentMatchPolicy?: YT_CONTENT_MATCH_POLICY | null;
}

export enum DELIVERY_METHOD {
  unknown = -1,
  Ddex382 = 0,
  Ddex43 = 1,
  Manual = 2,
}

export enum TRANSFER_METHOD {
  unknown = -1,
  Blob = 0,
  Ftp = 1,
  Sftp = 2,
}
